import { RefObject, useEffect, useState } from 'react';
import noop from './noop';

const buildThresholdList = (stepsCount: number) => {
  const thresholds: number[] = [0];

  for (let i = 1; i <= stepsCount; i += 1) {
    const ratio = i / stepsCount;
    thresholds.push(ratio);
  }

  return thresholds;
};

const useIntersectionRatio = (targetRef: RefObject<HTMLElement>): number => {
  const [intersectionRatio, setIntersectionRatio] = useState(0);

  useEffect(() => {
    if (targetRef.current && typeof IntersectionObserver === 'function') {
      const handler: IntersectionObserverCallback = ([entry]) => {
        setIntersectionRatio(entry.intersectionRatio);
      };

      const options: IntersectionObserverInit = { threshold: buildThresholdList(20) };

      const observer = new IntersectionObserver(handler, options);
      observer.observe(targetRef.current);

      return () => {
        observer.disconnect();
      };
    }

    return noop;
  }, [targetRef]);

  return intersectionRatio;
};

export default useIntersectionRatio;
